import React, { useState } from "react";
import EyeFillIcon from "./icons/eye-fill-icon";
import CloseCircleFillIcon from "./icons/close-circle-fill-icon";
import makeRequest from '../../../../libs/requestOther'

export const contentTypes = {
	// Văn bản
	document: "application/msword",
	docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
	pdf: "application/pdf",
	txt: "text/plain",
	rtf: "application/rtf",

	// Bảng tính
	excel: "application/vnd.ms-excel",
	xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	csv: "text/csv",

	// Bài thuyết trình
	powerpoint: "application/vnd.ms-powerpoint",
	pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",

	// Hình ảnh
	jpg: "image/jpeg",
	jpeg: "image/jpeg",
	png: "image/png",
	gif: "image/gif",
	bmp: "image/bmp",
	svg: "image/svg+xml",
	webp: "image/webp",

	// Video
	mp4: "video/mp4",
	avi: "video/x-msvideo",
	mov: "video/quicktime",
	mkv: "video/x-matroska",
	webm: "video/webm",

	// Âm thanh
	mp3: "audio/mpeg",
	wav: "audio/wav",
	ogg: "audio/ogg",
	flac: "audio/flac",

	// Code
	python: "text/x-python",
	javascript: "application/javascript",
	html: "text/html",
	css: "text/css",
	json: "application/json",
	xml: "application/xml",
	java: "text/x-java-source",
	c: "text/x-c",
	cpp: "text/x-c++",
	php: "application/x-httpd-php",
	sql: "application/sql",
	ruby: "text/x-ruby",
	go: "text/x-go",
	rust: "text/x-rust",
	swift: "text/x-swift",
	csharp: "text/x-csharp",
	typescript: "application/typescript",

	// Nén
	zip: "application/zip",
	rar: "application/vnd.rar",
	tar: "application/x-tar",
	gz: "application/gzip",
};

export default function RenderImage(props) {
	const [loaded, setLoaded] = useState();
	const showImage = () => {
		setLoaded(true);
	};

	const getImage = async () => {
		let content_type = contentTypes[props.image.url?.split(".").pop()];
		let link
		await makeRequest('post', `uploads/preview-file`, {
			url: props.image.url,
			content_type,
		})
			.then(({ data }) => {
				if (data?.data) {
					link = data?.data
					return data?.data;
				}
			})
			.catch((err) => {
				console.log('++++++++++++++++', err)
			})
		if (link) {
			window.open(link, "_blank");
		}
	};

	return (
		<div className={`upload-list-container ${props?.className}`} key={props.image.uid} style={{ position: "relative" }}>
			<span>
				<div className="upload-list-item">
					<div className="upload-list-item-info">
						<span>
							{props?.image?.url &&
								(props?.notShowImageLoading ? (
									<a
										className="upload-list-item-thumbnail"
										href={props?.image.url}
										target="_blank"
										rel="noopener noreferrer"
									>
										<img src={props?.image?.url} alt="" className="upload-list-item-image" />
									</a>
								) : (
									<a
										className="upload-list-item-thumbnail"
										href={props.image.url}
										target="_blank"
										rel="noopener noreferrer"
										style={{
											position: "relative",
											minWidth: "100%",
											minHeight: "100%",
											display: "flex",
											textAlign: "center",
											justifyContent: "center",
											overflow: "hidden",
											border: "none",
										}}
									>
										<div
											style={
												loaded
													? { display: "none" }
													: {
														position: "relative",
														minWidth: "100%",
														minHeight: "100%",
														display: "flex",
														textAlign: "center",
														justifyContent: "center",
														overflow: "hidden",
														border: "none",
													}
											}
										>
											<img
												src="/images/upload.svg"
												alt="images"
												style={{
													width: "auto",
													height: "auto",
													minWidth: "100%",
													minHeight: "100%",
													maxWidth: "auto !important",
													maxHeight: "auto !important",
												}}
											/>
											<div
												style={{
													position: "absolute",
													minWidth: "100%",
													minHeight: "100%",
													background: "#00000080",
												}}
											></div>
										</div>
										<img
											src={props.image.url}
											onLoad={showImage}
											alt=""
											style={loaded ? {} : { display: "none" }}
											className={"upload-list-item-image"}
										/>
									</a>
								))}
						</span>
					</div>
					{props?.hiddenEdit ? (
						<></>
					) : (
						<span className="upload-list-item-actions">
							<a
								// href={props.image.url}
								// target="_blank"
								className="d-flex align-items-center"
								rel="noopener noreferrer"
								title="Preview image"
								onClick={() => {
									getImage();
								}}
							>
								<span role="img" aria-label="eye" className="cursor-pointer row-center">
									<EyeFillIcon />
								</span>
							</a>
							{!props?.disabled ? (
								<span
									role="img"
									aria-label="delete"
									tabIndex="-1"
									className="cursor-pointer row-center"
									onClick={() => props.removeFile(props.image.url)}
									title="Remove"
								>
									<CloseCircleFillIcon />
								</span>
							) : (
								""
							)}
						</span>
					)}
				</div>
			</span>
		</div>
	);
}
